export default "__VITE_ASSET__CNfL88V$__"